<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-03-08 15:18:35
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-03-13 11:13:06
 * @FilePath: \official_website\src\mobile\pages\products\Product.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div id="solution"> 
    <Header></Header>
    <div class="solution-top">
      <p class="title animate__animated animate__fadeInDown">解决方案</p>
    </div>
    <div class="solution-content">
      <div
        class="solution-solutions"
        v-for="(items, indexs) in solutionList"
        :key="indexs"
      >
        <div class="solution-header">
          <h4 class="title">
            {{ items.title }}
          </h4>
        </div>
        <ul class="solution-box">
          <li
            class="solution-item"
            v-for="(item, index) in items.children"
            :key="index"
            @click="tapPages(item.path)"
          >
            <img class="solution-img" :src="item.src"  alt="产品及解决方案"/>
            <div class="solution-text">{{ item.lable }}</div>
          </li>
        </ul>
      </div>
    </div>

    <div class="footer">
      <Footer></Footer>
    </div>
  </div>
</template>
    
<script>
import api from "../../../api/api";
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
export default {
  name: "",
  props: {},
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      solutionList: [
        {
          title: "解决方案",
          children: [
            {
              src: require("@/assets/image/product/solution3.png"),
              lable: "宫颈癌筛查解决方案",
              path: "/solution/tbs",
              prodId: 29,
            },
            {
              src: require("@/assets/image/product/solution1.png"),
              lable: "DNA倍体癌症早筛解决方案",
              path: "/solution/dna",
              prodId: 28,
            },
            {
              src: require("@/assets/image/product/solution4.png"),
              lable: "远程病理诊断解决方案",
              path: "/solution/telepathology",
              prodId: 27,
            },
            {
              src: require("@/assets/image/product/solution2.png"),
              lable: "血液细胞形态诊断解决方案",
              path: "/solution/blood",
              prodId: 26,
            },
          ],
        },
      ],
    };
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    tapPages(path) {
      this.$router.push(path);
    },
  },
};
</script>
    
<style lang="scss">
#solution {
  padding-top: 3.75rem;
  .solution-top {
    position: relative;
    width: 100%;
    height: 8rem;
    background-image: url("../../../assets/image/product/header.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    .title {
      position: absolute;
      left: 1.25rem;
      top: 20%;
      transform: translateY(-50%);
      color: #fff;
      font-size: 1.25rem;
      font-family: "SourceHanSansSC-Medium";
    }
  }
  .solution-content {
    margin-bottom: 2rem;
    .solution-solutions {
      .solution-header {
        padding: 1.5rem 1.25rem;
        .line {
        }
        .title {
          position: relative;
          padding-top: 1.5rem;
          font-size: 1.5rem;
          // margin-bottom: 1.5rem;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 4.5rem;
            height: 0.625rem;
            background-color: #0b847b;
            -webkit-transition: width 0.5s ease-out 0.8s;
            transition: width 0.5s ease-out 0.8s;
          }
        }
        .description {
        }
      }
      .solution-box {
        padding: 0 1.25rem;
        .solution-item {
          padding: 1rem 0;
          .solution-img {
            width: 100%;
          }
          .solution-text {
            padding: 1rem 1.25rem;
            font-size: 1.2rem;
            font-family: "SourceHanSansSC-Medium";
            background-color: #fafafa;
          }
        }
      }
    }
  }

  .footer {
    background: #f5f5f5;
  }
}
</style>